const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		roleOptionScope: 'mblx',
		usageMode: '', // may be "choose" for move-to-product chooser
	},

	model: {
		entityTable: false
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				if($target.length > 0){
					var fieldType = $target.data('fieldType');
					if(self.model.entityTable){
						if(fieldType === 'export') {
							self.model.entityTable.export()
						} else if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						} else if(fieldType === 'showInsert'){
							self.model.entityTable.showInsert()
						} else if(fieldType === 'requestProductsAdditionalInformation'){
							const resourceFilters 	= utils.copy(self.model.entityTable.getResourceFilters(self.getStorage(), undefined, 'refreshResources')) || {}
							const {nrOfMatchingElements} = (((self.model.entityTable.resourceData || {}).nrOfElements || {}).data || {}).attributes || {}
							const nrOfEditStatusPimElements = (self.model.entityTable.resourceData || {}).nrOfEditStatusPimElements || 0
							getComponent('mblxController').requestProductAdditionalInformation('productFilters', undefined, undefined, resourceFilters.filters || {}, nrOfMatchingElements, nrOfEditStatusPimElements)
						}
					}
				}
			}
		}
	},

	methods: {
		toggleRowSelection: function(rowID, rowData){
			this.triggerFind('toggleRowSelection', {
				rowID,
				rowData
			});

			if(this.config.usageMode === 'choose'){
				const routeID = ((rowData || {}).attributes || {}).routeID || 0
				return this.performAndStoreAction(
					'showEdit_product_inEffect',
					this.prepareAction(
						'showEdit_product',
						undefined,
						{
							routeTreeParent: utils.replace(rowData, { resourceID: routeID }),
						}
					),
					true
				)
			}
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.entityTable){
				self.find('base_tableSimple_table', function(entityTable){
					self.model.entityTable = entityTable;
				});
			}
		},

		filtersChanged: function($element, options){
			this.triggerFind('filtersChanged', options);
		},

		colTagsBubbleSelected: function($element, options){
			this.triggerFind('colTagsBubbleSelected', options);
		},

		showColumnDescription: function ($element, options) {
			this.triggerFind('showColumnDescription', options);
		},

		hideColumnDescription: function ($element, options) {
			this.triggerFind('hideColumnDescription', options);
		},

		onTableSelectionChanged: function($element, options) {
			this.triggerFind('onTableSelectionChanged', options);
		},
	}
};
